import { DataGrid, SelectBox } from "devextreme-react";
import React, { useCallback, useMemo } from "react";
import { getPropsDataGrid, getPropsDateEdit, getPropsDataGridEditing, getPropsDataGridPopup } from "../../../utils/default-props";
import { Column, Editing, FormItem, Lookup, Popup } from "devextreme-react/data-grid";
import { useDataSource } from "../../../contexts/dataSource";
import { useAuth } from "../../../contexts/auth";
import { getDataGridCustomToolbar } from "../../../components/default-components/data-grid-custom-toolbar";
import { useLookupGroup } from "../../../contexts/lookup-group-context";
import { useState } from "react";
import { useEffect } from "react";
import { lookupGroups } from "../../../utils/lookup-groups.ts";
import { getSelectBoxPropertiesIdText, getSelectBoxPropertiesIdName } from "../../../utils/default-props.js";
import { passportStatusTypes, travelInsturanceStatusTypes, vaccinationStatusTypes } from "../../../utils/lookup-groups.ts";



function Travel(props) {
  const { employeeId } = props
  const { dataSourceHR } = useDataSource()
  const { user, activeLanguage } = useAuth()
  const { getLookupData } = useLookupGroup()

  const [policyTypeList, setPolicyTypeList] = useState()

  const dataSource = useMemo(() => dataSourceHR({
    loadUrl: `/api/EmployeeTravelPlan/GetListByEmployeeId?employeeId=${employeeId}`,
  }), [employeeId, dataSourceHR])



  const handleInitNewRow = useCallback((e) => {
    e.data.employeeId = employeeId
    e.data.active = true
  }, [employeeId])

  useEffect(() => {
    getLookupData(lookupGroups.policyType).then(response => {
      setPolicyTypeList(response)
    })
  }, [activeLanguage])

  const dbEmployeeTravelTransport = useMemo(() =>
    dataSourceHR({
      loadUrl: `/api/EmployeeTravelTransport`,
      loadMode: "raw"
    }), [user]);

  const dbEmployeeTravelAccommodation = useMemo(() =>
    dataSourceHR({
      loadUrl: `/api/EmployeeTravelAccommodation`,
      loadMode: "raw"
    }), [user]);

  const dbVaccinationStatus = useMemo(() =>
    dataSourceHR({
      loadUrl: `/api/LookupData/LookupGroup/${vaccinationStatusTypes.id}`,
      loadMode: "raw"
    }), [user]);

  const dbPassportStatus = useMemo(() =>
    dataSourceHR({
      loadUrl: `/api/LookupData/LookupGroup/${passportStatusTypes.id}`,
      loadMode: "raw"
    }), [user]);

  const dbTravelInsuranceStatus = useMemo(() =>
    dataSourceHR({
      loadUrl: `/api/LookupData/LookupGroup/${travelInsturanceStatusTypes.id}`,
      loadMode: "raw"
    }), [user]);


  return (
    <React.Fragment>
      <DataGrid
        {...getPropsDataGrid}
        dataSource={dataSource}
        onInitNewRow={handleInitNewRow}
      >
        <Editing {...getPropsDataGridEditing}>
          <Popup {...getPropsDataGridPopup} title="Sigorta Bilgisi" />
        </Editing>

        {getDataGridCustomToolbar("Seyahat Bilgileri")}
        <Column dataField="fromWhere"
          caption="Nereden"
        />
        <Column dataField="toWhere"
          caption="Nereye"
        />
        <Column dataField="startDate"
          caption="Başlangıç Tarihi"
          {...getPropsDateEdit}
        />
        <Column dataField="endDate" caption="Bitiş Tarihi"
          {...getPropsDateEdit}
        />
        <Column dataField="employeeTravelTransportId" caption="Ulaşım">
          <Lookup
            dataSource={dbEmployeeTravelTransport}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>
        <Column dataField="employeeTravelAccommodationId" caption="Konaklama">
          <Lookup
            dataSource={dbEmployeeTravelAccommodation}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>
        <Column dataField="vaccinationStatusTypeId" caption="Aşı">
          <Lookup
            dataSource={dbVaccinationStatus}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>
        <Column dataField="passportStatusTypeId" caption="Pasaport">
          <Lookup
            dataSource={dbPassportStatus}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>
        <Column dataField="travelInsuranceStatusTypeId" caption="Seyahat Sigortası">
          <Lookup
            dataSource={dbTravelInsuranceStatus}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>
        <Column dataField="approvalStatus"
          caption="Onay"
        />
        <Column dataField="approvalDate"
          caption="Onaylanma Tarihi"
        />
      </DataGrid>

    </React.Fragment>
  )
}

export default Travel